<script setup>
import { defineProps } from 'vue';
const props = defineProps({
    type: {
        type: String,
        default: 'default'
    },
    disabled: {
        type: Boolean,
        default: false
    }
});
</script>
<template>
    <button
        class="primary-button"
        :class="{
            'primary-button--default': props.type === 'default',
            'primary-button--primary': props.type === 'primary',
            'secundary-button': props.type === 'secundary',
            'primary-button--disabled': props.disabled
        }"
        :disabled="props.disabled"
        >
        <slot />
    </button>
</template>

<style scoped lang="postcss">
.primary-button {
    @apply inline-flex items-center justify-center px-4 py-1.5 2xl:px-6 2xl:py-2.5 border border-transparent rounded-lg text-xs 2xl:text-sm text-white font-semibold tracking-wide focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 dark:focus:ring-offset-gray-800 transition ease-in-out duration-150 shadow-sm hover:shadow;
}

.primary-button--default {
    @apply bg-echoes-primary text-white hover:bg-echoes-primary/80 transition-colors duration-200 ease-in-out;
}

.primary-button--primary {
    @apply bg-green-600 hover:bg-green-700 transition-colors duration-200 ease-in-out;
}

.secundary-button {
    @apply bg-echoes-background-gray hover:bg-echoes-background-gray/80 transition-colors duration-200 ease-in-out;
}

.primary-button--disabled {
    @apply opacity-50 cursor-not-allowed;
}

</style>